export default {"src":"/_next/static/media/secondary-school-icon.845c25e3.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};